<div class="tw-flex tw-w-full tw-my-3" [ngClass]="[content.actionAlignment]">
  <div (click)="launchAction()" class="tw-cursor-pointer" [ngClass]="[content.actionDisplay]">
    {{ content.actionText }}
  </div>
</div>